import {
  Button,
  Checkbox,
  Chip,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { DropzoneArea } from 'mui-file-dropzone';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { GridComponent } from 'src/components/common/GridComponent';
import Loader from 'src/components/common/Loader';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { sendRequest } from 'src/hooks/useFetch';
import { useAppDispatch } from 'src/store';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { useAppSelector } from 'src/store/hooks';
import { IDocumentArtifactInfo, IUploadedDocumentISF } from 'src/types/UploadedDocumentISF';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { formatInput } from 'src/util/STR';
import './DocumentUpload.scss';
import { useDocumentUploads } from './useDocumentUploads';

interface stateDocs {
  documentMetaData: any;
  setDocumentMetaData: any;
  uploadedFile: any;
  isFileUploaded: () => boolean;
  setUploadedFile: any;
  clearData: any;
  error: string | null;
  trainingLogsAPI: any;
  selectedTrainingLogId: string;
  openUploadDocument?: boolean;
  setOpenUploadDocument: any;
  updateLogDocs: any;
}

export const TrainingDocUpload = (props: stateDocs) => {
  const [isUpload, setIsUpload] = useState<boolean>(false);
  const [enable, setEnable] = useState<boolean>(false);
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const { checkPermission } = usePermissionWrapper();
  const dispatchApp = useAppDispatch();
  const {
    getISFDocInfoByLevelTypeArtifactNameDataQuery,
    getAllISFDocInfoByArtifactNumberSiteLevelData,
    createMasterDocumentIsf,
    deleteMasterDocumentIsf
  } = useDocumentUploads();
  const [dfile, setDfile] = useState<any>(null);
  const [styleUpload, setStyleUpload] = useState('uploadFile');
  const error = null;
  const [docName, setDocName] = useState<string>('');

  const [deleteDocFileMasterId, setDeleteFileMasterDocId] = useState('');
  const [openDeleteDocPopup, setOpenDeleteDocPopup] = useState(false);
  const [selectedTrainingDocsList, setSelectedTrainingDocsList] = useState<any>([]);
  const [fileChipList, setFileChipList] = useState<any[]>([]);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);

  const [includesPHICheck, setIncludesPHICheck] = useState<boolean>(false);
  const [fileUploadData, setFileUploadData] = useState<IUploadedDocumentISF>({
    isf_prefix: '',
    isf_raw_file_name: '',
    isf_bucket_name: '',
    isf_hashed_file_name: '',
    isf_doc_version_number: 0,
    isf_doc_size: '',
    isf_doc_type: '',
    isf_doc_viewer_pages: '',
    id: '',
    is_active: false,
    isf_doc_created_by: '',
    isf_doc_upload_date: '',
    created_on: '',
    updated_on: ''
  });
  const [artifactInfo, setArtifactInfo] = useState<IDocumentArtifactInfo>({
    isf_artifact_number: '',
    isf_artifact_name: '',
    isf_doc_type: '',
    isf_doc_subtype: '',
    isf_doc_milestone: ''
  });

  const { duFileUploadErrorMsg } = useFieldTranslation();

  const useStyles = makeStyles(() =>
    createStyles({
      previewChip: {
        minWidth: 160,
        maxWidth: 210
      }
    })
  );

  const classes = useStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    if (isUpload) {
      if (error) {
        setStyleUpload('uploadFileError');
      } else {
        setStyleUpload('uploadFileSuccess');
      }
    } else {
      setStyleUpload('uploadFile withFakeBtn');
    }
  }, [isUpload, error]);
  const handleRejectedMessage = (rejectedFile: any, acceptedFiles: any, maxFileSize: any) => {
    let message = `${rejectedFile.name} cannot be uploaded! , `;
    const arrFile = rejectedFile.name.split('.');
    if (!acceptedFiles.includes(`.${arrFile[arrFile.length - 1]}`)) {
      message += `File Format is not supported`;
    } else if (rejectedFile.size > maxFileSize) {
      message += `File Size more than 5MB is not allowed.`;
    }
    // setError(message);
    return message;
  };

  const handleDocumentName = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    setDocName(formattedVal);
    //props.setAddDocDetails({ ...props.addDocDetails, document_name: formattedVal });
  };
  const handleDialoBox = () => {
    setEnable(true);
  };
  const handleClose = () => {
    setEnable(false);
  };

  const handleUploadDocument = async () => {
    const check = await uploadDataFile();
    if (!check) {
      return;
    }
    if (docName !== '') {
      const isDocNameExists = selectedTrainingDocsList.some(
        (existedDoc: any) => existedDoc.document_data.isf_document_name === docName
      );
      if (!isDocNameExists) {
        try {
          dispatch(showLoader());
          const isfUploadDocObj = {
            file_master_id: check.id,
            document_data: {
              isf_artifact_number: artifactInfo.isf_artifact_number,
              isf_document_name: docName,
              isf_doc_type: artifactInfo.isf_doc_type,
              isf_doc_subtype: artifactInfo.isf_doc_subtype,
              isf_doc_viewer_includes_phi: includesPHICheck,
              isf_doc_viewer_red_certified_copy: 'N',
              isf_doc_status: 'Uploaded',
              isf_doc_country: selectedCountry,
              isf_doc_study: studyId,
              isf_doc_site: selectedSite,
              isf_doc_viewer_department: 'None',
              isf_doc_viewer_language: 'English',
              isf_doc_viewer_approval_cycle: 0,
              isf_doc_viewer_product_detail: 'test1',
              isf_doc_viewer_ref_model_version: 'ISF RM v1.0',
              isf_doc_viewer_format: 'PDF',
              isf_doc_viewer_inspection_ready: '',
              isf_doc_viewer_ir_issue_type: '',
              isf_doc_level: 'Site',
              isf_artifact_name: artifactInfo.isf_artifact_name,
              isf_doc_version_number: check.isf_doc_version_number,
              isf_doc_milestone: artifactInfo.isf_doc_milestone,
              isf_document_id: 'str',
              isf_doc_viewer_doc_phi_redacted: 'N',
              isf_doc_viewer_created_by: check.isf_doc_created_by
            }
          };
          const result: any = await createMasterDocumentIsf({
            data: isfUploadDocObj,
            study_id: studyId,
            country: selectedCountry,
            site_id: selectedSite,
            application: process.env.REACT_APP_NAME,
            module_section_related: 'STUDY LOGS',
            parent_entity_related: ''
          });
          const response = result?.data;
          const updatedDocIds: string[] = [];
          selectedTrainingDocsList.map((doc: any) => {
            updatedDocIds.push(doc.document_data.id);
          });
          updatedDocIds.push(response.document_data.id);
          dispatch(hideLoader());
          props.updateLogDocs(updatedDocIds);
          props.setOpenUploadDocument(false);
        } catch (error: any) {
          dispatch(hideLoader());
          dispatch(setMessage({ msgDetails: duFileUploadErrorMsg, severity: 'error' }));
        }
      } else {
        dispatch(setMessage({ msgDetails: 'Duplicate document identified.', severity: 'error' }));
      }
    } else {
      dispatch(setMessage({ msgDetails: 'Document name is missing', severity: 'error' }));
    }
  };
  const handleDocDeleteconfirm = async () => {
    try {
      handleDocDeletePopupClose();
      dispatch(showLoader());
      await deleteMasterDocumentIsf({
        file_master_id: deleteDocFileMasterId,
        study_id: studyId,
        country: selectedCountry,
        site_id: selectedSite,
        application: process.env.REACT_APP_NAME,
        module_section_related: 'STUDY LOGS',
        parent_entity_related: ''
      });
      const updatedDocIds: string[] = [];
      selectedTrainingDocsList.map((doc: any) => {
        if (doc.file_master.id !== deleteDocFileMasterId) {
          updatedDocIds.push(doc.document_data.id);
        }
      });
      props.updateLogDocs(updatedDocIds, true);
      props.setOpenUploadDocument(false);
      dispatch(hideLoader());
    } catch (error: any) {
      dispatch(hideLoader());
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else {
        dispatchApp(setMessage({ msgDetails: 'Error in Document Delete', severity: 'error' }));
      }
    }
  };

  const getISFDocInfo = async (artifactName: string | undefined) => {
    try {
      dispatch(showLoader());
      const docResult: any = await getISFDocInfoByLevelTypeArtifactNameDataQuery({
        level_type: 'Site',
        artifactName,
        study_id: studyId,
        country: selectedCountry,
        site_id: selectedSite,
        application: process.env.REACT_APP_NAME,
        module_section_related: 'STUDY LOGS',
        parent_entity_related: ''
      });
      setArtifactInfo({
        ...docResult?.data,
        isf_artifact_name: props.documentMetaData?.name
      });
      dispatch(hideLoader());
    } catch (error: any) {
      dispatch(hideLoader());
      // if (error && error?.response?.status === 403) {
      //   dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      // } else if (error && error.response?.status === 401) {
      //   dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      // } else {
      //   dispatch(setMessage({ msgDetails: 'Error while getting document info', severity: 'error' }));
      // }
    }
  };
  const getDocVersion = (): string | number => {
    return fileUploadData.isf_doc_version_number === 0 ? '' : fileUploadData.isf_doc_version_number.toFixed(1);
  };
  const uploadFile = async (file: any): Promise<IUploadedDocumentISF> => {
    try {
      dispatch(showLoader());
      const formData = new FormData();
      formData.append('file', file);
      const options = {
        endPointEnv: 'isf',
        data: formData,
        pathVariables: {
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          appName: process.env.REACT_APP_NAME,
          module_section_related: 'STUDY LOGS',
          parent_entity_related: ''
        }
      };
      const response: any = await sendRequest('isf_file_master_upload_file', options);
      dispatch(hideLoader());
      return response;
    } catch {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: duFileUploadErrorMsg, severity: 'error' }));
      return Promise.reject();
    }
  };
  const uploadDataFile = async (): Promise<any> => {
    if (dfile) {
      const result = await uploadFile(dfile);
      if (result) {
        setFileUploadData(result);
        return result;
      } else {
        return false;
      }
    }
  };

  const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIncludesPHICheck(event.target.checked);
  };
  useEffect(() => {
    if (dfile) {
      setIsUpload(true);
    } else {
      setIsUpload(false);
    }
  }, [dfile]);
  useEffect(() => {
    if (props.openUploadDocument) {
      getISFDocInfo(props.documentMetaData?.name);
      getFileChipList(props.selectedTrainingLogId);
    }
  }, [props.openUploadDocument]);

  const handleDocDeletePopupClose = () => {
    setOpenDeleteDocPopup(false);
  };
  const handleDocDeleteDialog = (docFileMasterId: string) => {
    setDeleteFileMasterDocId(docFileMasterId);
    setOpenDeleteDocPopup(true);
  };

  const getFileChipList = async (selectedRecordId: string) => {
    if (props.trainingLogsAPI.length > 0) {
      const chipsArray: any[] = [];
      dispatch(showLoader());
      props.trainingLogsAPI.map((log: any) => {
        log.Trainings?.map(async (trngs: any) => {
          if (trngs.id === selectedRecordId) {
            let docsListTrainingLog: any[] = [];
            try {
              const result: any = await getAllISFDocInfoByArtifactNumberSiteLevelData({
                site_id: selectedSite,
                study_id: studyId,
                country: selectedCountry,
                artifactName: props.documentMetaData?.name,
                artifactNumber: props.documentMetaData?.number,
                originally_uploaded: true,
                application: process.env.REACT_APP_NAME,
                module_section_related: 'STUDY LOGS',
                parent_entity_related: ''
              });
              if (result.isSuccess && result?.data?.selected_data.length > 0) {
                docsListTrainingLog = result?.data?.selected_data.filter((docToLink: any) =>
                  trngs.file_ids.includes(docToLink.document_data.id)
                );
              }
              dispatch(hideLoader());
            } catch (error: any) {
              dispatch(hideLoader());
              // if (error && error?.response?.status === 403) {
              //   dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
              // } else if (error && error.response?.status === 401) {
              //   dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
              // }
            }
            setSelectedTrainingDocsList(docsListTrainingLog);
            if (docsListTrainingLog.length > 0) {
              docsListTrainingLog.map((trngDoc: any, index: number) => {
                checkPermission('delete_siv_training_doc')
                  ? chipsArray.push(
                      <Chip
                        size="small"
                        color="primary"
                        key={index}
                        label={trngDoc.document_data.isf_document_name}
                        variant="outlined"
                        onDelete={() => handleDocDeleteDialog(trngDoc.file_master.id)}
                      />
                    )
                  : chipsArray.push(
                      <Chip
                        size="small"
                        color="primary"
                        key={index}
                        label={trngDoc.document_data.isf_document_name}
                        variant="outlined"
                      />
                    );
              });
            }
            setFileChipList(chipsArray);
          }
        });
      });
      dispatch(hideLoader());
    }
  };

  return (
    <div className="document-upload-page" style={{ marginTop: '8px', marginBottom: '-8px' }}>
      <div className="card">
        <Grid container spacing={3}>
          <Loader />
          <Grid item md={12}>
            <div
              id="uploadFile"
              className={checkPermission('upload_siv_training_doc') ? styleUpload : `${styleUpload} noUploadCase`}
            >
              <DropzoneArea
                fileObjects={[]}
                showPreviewsInDropzone={isUpload}
                filesLimit={1}
                showAlerts={['error', 'info']}
                maxFileSize={5000000}
                acceptedFiles={[
                  '.jpg',
                  '.jpeg',
                  '.gif',
                  '.png',
                  '.bmp',
                  '.tif',
                  '.tiff',
                  '.psd',
                  '.pdf',
                  '.doc',
                  '.docx',
                  '.xls',
                  '.xlsx'
                ]}
                useChipsForPreview
                showFileNames={false}
                dropzoneText={
                  isUpload ? 'Your file upload has been successfully initiated' : `Drag and drop your file here or`
                }
                previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                previewChipProps={{ classes: { root: classes.previewChip } }}
                previewText="Selected files"
                onChange={e => {
                  if (e.length > 0) {
                    setIsUpload(true);
                    setDfile(e[0]);
                    dispatch(setMessage({ msgDetails: `Your file ${e?.[0]?.name} has been successfully uploaded.`, severity: 'success' }));
                  }
                }}
                getFileLimitExceedMessage={(filesLimit: number) =>
                  'You cannot upload more than one file at once. Please try with single file'
                }
                getDropRejectMessage={handleRejectedMessage}
              />
              <Typography
                variant="body2"
                display="block"
                color="text.secondary"
                gutterBottom
                sx={{ mt: -4, textAlign: 'center', position: 'relative', zIndex: 12 }}
              >
                <strong>Accepted file type:&nbsp;</strong>
                {[
                  '.jpg',
                  '.jpeg',
                  '.gif',
                  '.png',
                  '.bmp',
                  '.tif',
                  '.tiff',
                  '.psd',
                  '.pdf',
                  '.doc',
                  '.docx',
                  '.xls',
                  '.xlsx'
                ].toString()}
              </Typography>
            </div>
          </Grid>
          <Grid item md={12}>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled={!isUpload}
                    required
                    id="standard-select-currency-native"
                    label="Document Name "
                    variant="standard"
                    value={docName}
                    inputProps={{
                      maxLength: 200
                    }}
                    onChange={e => handleDocumentName(e)}
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    label="Version Number"
                    variant="standard"
                    value={getDocVersion()}
                  >
                    <MenuItem value={getDocVersion()}>{getDocVersion()}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    required
                    label="Artifact Number"
                    variant="standard"
                    value={artifactInfo.isf_artifact_number}
                  >
                    <MenuItem value={artifactInfo.isf_artifact_number}>{artifactInfo.isf_artifact_number}</MenuItem>
                  </TextField>
                </FormControl>
              </Grid>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    required
                    label="Artifact Name"
                    variant="standard"
                    value={artifactInfo.isf_artifact_name}
                  >
                    <MenuItem value={artifactInfo.isf_artifact_name}>{artifactInfo.isf_artifact_name}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    label="Type"
                    variant="standard"
                    value={artifactInfo.isf_doc_type}
                  >
                    <MenuItem value={artifactInfo.isf_doc_type}>{artifactInfo.isf_doc_type}</MenuItem>
                  </TextField>
                </FormControl>
                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    label="Upload Date"
                    placeholder={userPreferedDateFormat.toLowerCase()}
                    variant="standard"
                    type={isUpload ? 'text' : ''}
                    value={isUpload ? preferedDateFormat(fileUploadData.created_on.slice(0, 10)) : ''}
                  />
                </FormControl>
              </Grid>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-required"
                    select
                    label="Milestone"
                    value={artifactInfo.isf_doc_milestone}
                    variant="standard"
                    InputProps={{
                      readOnly: true
                    }}
                  >
                    <MenuItem value={artifactInfo.isf_doc_milestone}>{artifactInfo.isf_doc_milestone}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    label="Subtype"
                    variant="standard"
                    value={artifactInfo.isf_doc_subtype}
                  >
                    <MenuItem value={artifactInfo.isf_doc_subtype}>{artifactInfo.isf_doc_subtype}</MenuItem>
                  </TextField>
                </FormControl>
                <FormControlLabel
                  control={<Checkbox disabled={!isUpload} checked={includesPHICheck} onChange={handleCheckBox} />}
                  label="Includes PHI?"
                />
              </Grid>
            </Grid>
            {fileChipList.length > 0 && (
              <GridComponent sx={{ my: 2 }}>
                <Stack direction="row" spacing={0} className="upload-doc-chip withWrap maxShow3">
                  {fileChipList}
                </Stack>
              </GridComponent>
            )}

            <PopupComponent
              open={openDeleteDocPopup}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              child
            >
              <DialogTitle id="alert-dialog-title">{'Delete the document?'}</DialogTitle>
              <DialogContent sx={{ minWidth: 360 }}>Do you want to delete the document?</DialogContent>
              <DialogActions>
                <Button onClick={handleDocDeleteconfirm} autoFocus className="grey-btn">
                  Yes
                </Button>
                <Button onClick={handleDocDeletePopupClose}>No</Button>
              </DialogActions>
            </PopupComponent>
            <Grid container spacing={2}>
              <Grid item md={12} display="flex" justifyContent="flex-end">
                <Stack direction="row" spacing={2}>
                  <Button variant="text" href="#contained-buttons" className="grey-btn" onClick={handleDialoBox}>
                    Cancel
                  </Button>
                  <PopupComponent
                    open={enable}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    child
                  >
                    <DialogTitle id="alert-dialog-title">{'Cancel Document Upload'}</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Are you sure you want to cancel uploading this document?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={props.clearData} className="grey-btn" autoFocus>
                        Yes
                      </Button>
                      <Button onClick={handleClose}>No</Button>
                    </DialogActions>
                  </PopupComponent>
                  <Button
                    variant="text"
                    href="#contained-buttons"
                    onClick={_ => handleUploadDocument()}
                    disabled={!dfile || !checkPermission('upload_siv_training_doc')}
                  >
                    Submit
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};
